import React, { useEffect, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import { styledDefaultColDef } from '../../extras/cellRenderers';
import { getListOfClassEvents } from '../../services/apiService';

function StatusBadge({ value }) {
  const isCompleted = value === 'Completed';
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '2px 10px',
        borderRadius: 9999,
        fontSize: 11.5,
        fontWeight: 600,
        backgroundColor: isCompleted ? '#e8ffea' : '#fff3e2',
        color: isCompleted ? '#07b616' : '#c9903d',
      }}
    >
      {value || '—'}
    </span>
  );
}

function ScheduleLssTable({ allCohorts, onViewClasses }) {
  const [rowData, setRowData] = useState([]);

  useEffect(() => {
    getListOfClassEvents()
      .then((data) => {
        if (Array.isArray(data)) setRowData(data);
        else if (data && Array.isArray(data.data)) setRowData(data.data);
      })
      .catch(() => setRowData([]));
  }, []);

  const columnDefs = [
    {
      headerName: 'EVENT NAME',
      field: 'eventName',
      flex: 2,
    },
    {
      headerName: 'COHORTS',
      field: 'cohorts',
      flex: 2,
      valueFormatter: (params) => {
        const val = params.value;
        if (Array.isArray(val)) return val.join(', ');
        return val || '—';
      },
    },
    {
      headerName: 'MODULE NAME',
      field: 'moduleName',
      flex: 2,
    },
    {
      headerName: 'STATUS',
      field: 'status',
      flex: 1,
      cellRendererFramework: (params) => <StatusBadge value={params.value} />,
    },
    {
      headerName: 'ACTIONS',
      field: 'actions',
      flex: 1,
      sortable: false,
      cellRendererFramework: (params) => (
        <button
          onClick={() => onViewClasses(params.data)}
          style={{
            border: '1px solid #E5E7EB',
            background: '#fff',
            color: '#4F46E5',
            borderRadius: 4,
            padding: '4px 12px',
            fontSize: 12,
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          View Classes
        </button>
      ),
    },
  ];

  return (
    <div
      style={{
        backgroundColor: '#fff',
        borderRadius: 16,
        border: '1px solid rgba(0,0,0,0.07)',
        boxShadow: '0 1px 6px rgba(0,0,0,0.05)',
        overflow: 'hidden',
      }}
    >
      <div className="ag-theme-alpine" style={{ width: '100%', height: 520 }}>
        <AgGridReact
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={styledDefaultColDef}
          rowHeight={48}
          headerHeight={44}
        />
      </div>
    </div>
  );
}

export default ScheduleLssTable;
